import { CUST_STATUS, KIND_LABEL, RECON_LABEL, STAGE_LABEL } from "@/lib/format";

const TONE = {
  green: "bg-emerald-50 text-emerald-800 border-emerald-300",
  red: "bg-rose-50 text-rose-800 border-rose-300",
  blue: "bg-sky-50 text-sky-800 border-sky-300",
  violet: "bg-violet-50 text-violet-800 border-violet-300",
  amber: "bg-amber-50 text-amber-800 border-amber-300",
  slate: "bg-slate-100 text-slate-700 border-slate-300",
};

export const LabelBadge = ({ text, tone = "slate", testId }) => (
  <span className={`inline-block whitespace-nowrap px-1.5 py-0.5 rounded-sm text-[10px] font-semibold tracking-wide border ${TONE[tone]}`} data-testid={testId}>{text}</span>
);

const ST_TONE = { aktif: "green", berhenti: "red", baru: "blue", aktif_kembali: "violet" };
export const CustStatusBadge = ({ status, testId }) => <LabelBadge text={CUST_STATUS[status || "aktif"]} tone={ST_TONE[status || "aktif"]} testId={testId} />;

const KIND_TONE = { reguler: "green", pasokan_awal: "violet", tidak_ada: "slate" };
export const KindBadge = ({ kind, testId }) => <LabelBadge text={KIND_LABEL[kind || "reguler"]} tone={KIND_TONE[kind || "reguler"]} testId={testId} />;

const RECON_TONE = { cocok: "green", lebih: "blue", kurang: "red", belum: "slate", perlu_pemeriksaan: "amber" };
export const ReconBadge = ({ status, testId }) => <LabelBadge text={RECON_LABEL[status]} tone={RECON_TONE[status]} testId={testId} />;

const STAGE_TONE = { draft: "slate", diperiksa: "blue", ditutup: "green" };
export const StageBadge = ({ stage, testId }) => <LabelBadge text={STAGE_LABEL[stage || "draft"]} tone={STAGE_TONE[stage || "draft"]} testId={testId} />;
